//拼多多打印组件Websocket地址：ws://127.0.0.1:5000；wss://127.0.0.1:18653
import basePrinter from "~/service/basePrinter";

const port = 5000
const url = 'ws://127.0.0.1:' + port
let socket = null
let connected = false

//支持
function doConnect() {
    socket = new WebSocket(url)
    socket.onopen = function (event) {
        console.log('拼多多打印组件连接成功')
        connected = true
        // 监听消息
        socket.onmessage = basePrinter.onMessage
        // 监听Socket的关闭
        socket.onclose = function (event) {
            connected = false
            console.log('拼多多打印组件连接关闭', event)
            //如果断开连接，自动1s后重新连接
            setTimeout(() => {
                doConnect()
                // socket
            }, 1000)
        }

    }

    socket.onerror = (error) => {
        console.error(`拼多多打印组件发生错误`, error)
    }
}

const execIfConnected = (func, ...args) => {
    if (getConnect()) {
        return func(...args)
    }
    return Promise.reject({
        message: '拼多多打印组件连接已断开！'
    })
}

// 获取打印机列表(getPrinters)
const getPrinters = () => {
    return execIfConnected(basePrinter.getPrinters, socket)
}


//暂不支持
// 获取打印机配置(getPrinterConfig)
const doPrinterConfig = printer => {
    return execIfConnected(basePrinter.getPrinterConfig, socket, printer)
}

// 设置打印机配置(setPrinterConfig)
const setPrinterConfig = options => {
    return execIfConnected(basePrinter.setPrinterConfig, socket, options)
}

// 发送打印/预览数据协议(print)
const print = (options) => {
    return execIfConnected(basePrinter.print, socket, options)
}

// 打印通知(notifyPrintResult) ignore
const notifyPrintResult = (options) => {
    return execIfConnected(basePrinter.notifyPrintResult, socket, options)
}

// 获取任务打印任务状态(getTaskStatus)
const getTaskStatus = (taskIDArray) => {
    return execIfConnected(basePrinter.getTaskStatus, socket, taskIDArray)
}

// 获取全局配置
const getGlobalConfig = () => {
    return execIfConnected(basePrinter.getGlobalConfig, socket)
}

// 设置全局配置
const setGlobalConfig = (notifyOnTaskFailure) => {
    return execIfConnected(basePrinter.setGlobalConfig, socket, notifyOnTaskFailure)
}

// 获取客户端版本信息(getAgentInfo)
const getAgentInfo = () => {
    return execIfConnected(basePrinter.getAgentInfo, socket)
}

const getConnect = () => {
    return connected
}

export default {
    doConnect,
    getConnect,
    getPrinters,
    doPrinterConfig,
    setPrinterConfig,
    print,
    notifyPrintResult,
    getTaskStatus,
    getGlobalConfig,
    setGlobalConfig,
    getAgentInfo
}



// WEBPACK FOOTER //
// ./src/utils/pddPrinter.js